import { Credentials } from "auth/modules/state";
import GraphiQL from "graphiql";
import "graphiql/graphiql.css";
import { BareLayout } from "layouts";
import React, { FC } from "react";

export interface AdminGraphProps {
    credentials: Credentials;
}

const AdminGraphView: FC<AdminGraphProps> = (props: AdminGraphProps) => {
    const api = window.xaStudioConfig?.apiUrl;
    function graphQLFetcher(graphQLParams: any) {
        return fetch(`${api}/graphql`, {
            body: JSON.stringify(graphQLParams),
            headers: {
                "Content-Type": "application/json",
                "x-xapp-usertoken": props.credentials.accessToken
            },
            method: "post"
        }).then((response: any) => response.json());
    }

    return (
        <BareLayout>
            <GraphiQL fetcher={graphQLFetcher} />
        </BareLayout>
    );
};

export { AdminGraphView };
